import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import MaskedInput from 'react-maskedinput';
import moment from 'moment';
import '../input/index.scss';

class DateInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { defaultDate: null };
  }

  componentDidMount() {
    // this is a workaround for autofill extensions that do not trigger change event when filling
    // the input value. the timeout will auto trigger the change at the end of the component lifecycle.
    // does not work with and thus filters by mask component version of Input.
    // (see imported <Input/> component for ref. )
    setTimeout(() => {
      if (
        this.refs.input &&
        !this.refs.input.mask &&
        this.refs.input.value != ''
      ) {
        this.props.onChange(this.props.name, this.refs.input.value, null);
      }
    }, 0);
  }

  onChangeProxy = (e) => {
    const { onChange, name } = this.props;

    onChange(name, e.target.value, e);
  };

  _hasError = () => {
    const { errors } = this.props;
    return errors.length > 0;
  };

  _isAndroid = () => {
    return (
      window.mobileDetect && window.mobileDetect.ua.indexOf('Android') > -1
    );
  };

  _renderMask = () => {
    const {
      name,
      mask,
      className,
      value,
      pattern,
      placeholder,
      onFocus,
      onBlur,
      maxLength,
    } = this.props;

    return (
      <MaskedInput
        mask={mask}
        // Add type tel for Android in order for numeric keyboard to behave correctly
        type={this._isAndroid() ? 'tel' : null}
        pattern={pattern}
        placeholderChar=" "
        name={name}
        className={className}
        placeholder={placeholder}
        ref={(c) => {
          this.input = c;
        }}
        value={value}
        autoComplete="off"
        onChange={this.onChangeProxy}
        onFocus={onFocus}
        onBlur={onBlur}
        maxLength={maxLength}
        data-testid={this.props['data-testid']}
      />
    );
  };

  render() {
    const { errors, theme } = this.props;
    const inputWrapperClasses = classnames('ui', 'input', `t-${theme}`, {
      error: this._hasError(),
      hidden: false,
    });

    return (
      <div
        className={inputWrapperClasses}
        ref={(c) => {
          this.input_wrapper = c;
        }}
      >
        {this._renderMask()}
        <span className="input-error">{errors[0] || ''}</span>
      </div>
    );
  }
}

DateInput.defaultProps = {
  placeholder: null,
  theme: 'Default',
  type: 'text',
  errors: [],
  className: '',
};

DateInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  theme: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
};

DateInput.displayName = 'DateInput';

export default DateInput;
